// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1-ExB","title":"Images45_title__2aGOM","images":"Images45_images__1dJXP"};